import { useState, useRef } from 'react';
import CodeMirror, { EditorView } from '@uiw/react-codemirror';
import jsyaml from 'js-yaml';
import { yaml } from '@codemirror/lang-yaml';

interface YamlEditorProps {
  value: string;
  label: string;
  onBlur: (value: string) => Promise<void>;
  onChange: (value: string) => void;
  extensions?: any[];
}

export function YamlEditor({ value, label, onBlur, extensions, onChange }: YamlEditorProps) {
  const [error, setError] = useState<string | null>(null);
  const editorViewRef = useRef<EditorView | null>(null);
  const ymlEditorExtensions = extensions ? [...extensions, yaml()] : [yaml()];

  const handleBlur = async () => {
    if (editorViewRef.current) {
      const editorValue = editorViewRef.current.state.doc.toString();
      handleChange(editorValue);
      await onBlur(editorValue);
    }
  };

  const handleChange = (input: string) => {
    try {
      jsyaml.load(input);
      onChange(input);
      setError(null);
    } catch (err: any) {
      setError(err.message);
    }
  };

  return (
    <>
      <CodeMirror
        extensions={ymlEditorExtensions}
        className='CodeMirror mw-100'
        value={value}
        onCreateEditor={(view: EditorView) => {
          editorViewRef.current = view;
        }}
        onChange={handleChange}
        onBlur={() => void handleBlur()}
        aria-label={label}
        editable
      />
      {error && (
        <p aria-label="Invalid Task" className="alert alert-danger text-wrap" role="alert">
         {error}
        </p>
      )}
    </>
  );
}
